declare var Swiper: any;

class TovarkeysStorageCostWizardForm {
  private form: HTMLFormElement;
  private $form: JQuery;
  private $buttonPrev: JQuery;
  private $buttonNext: JQuery;
  private buttonNextText: string;
  private swiper: any;
  private currentStep: number = 1;
  private totalSteps: number = 7;
  private isLastStep: boolean;

  constructor(selector: string) {
    this.form = document.querySelector(selector);

    if (!this.form) return;

    this.$form = jQuery(selector);
    this.$buttonPrev = this.$form.find('.button.prev');
    this.$buttonNext = this.$form.find('.button.next');
    this.buttonNextText = this.$buttonNext.text();

    this.swiper = new Swiper('#tovarkeys_storage_cost_wizard .swiper', {
      autoHeight: true,
      allowTouchMove: false,

      breakpoints: {
        1125: {
          autoHeight: false
        }
      }
    });

    this.$buttonPrev.on('click', () => {
      this.prev();
    });

    this.$buttonNext.on('click', () => {
      this.next();
    });

    this.$form.on('submit', () => {
      this.submit();
    });

    this.swiper.on('slideChange', () => {
      this.currentStep = this.swiper.activeIndex + 1;

      if (this.currentStep > this.totalSteps) {
        this.currentStep = this.totalSteps;
      }

      this.isLastStep = (this.currentStep == this.totalSteps);

      this.swiper.allowSlideNext = !this.isLastStep;

      this.update();
    });

    this.swiper.on('beforeSlideChangeStart', () => {});

    this.$form.find('.form-control').on('input', function () {
      jQuery(this).removeClass('invalid');
    });

    this.update();
  }

  public next() {
    if (this.isLastStep) {
      this.$form.submit();
    } else {
      this.swiper.slideNext();
    }
  }

  public prev() {
    this.swiper.slidePrev();
  }

  public submit() {
    if (!this.swiper.enabled) return;

    const formData = new FormData(this.form);
    const xhr = new XMLHttpRequest();

    this.swiper.enabled = false;
    this.$form.find('.invalid').removeClass('invalid');

    xhr.open('POST', '/wp-admin/admin-ajax.php', true);
    xhr.responseType = 'json';

    xhr.onload = () => {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          var data = xhr.response;

          for (const {name} of data.invalids) {
            const el = this.form.elements.namedItem(name) as HTMLElement | null;

            if (el instanceof HTMLElement) {
              el.classList.add('invalid');
            }
          }

          if (0 == data.invalids.length) {
            this.onSuccess();
          } else {
            this.onError(data.invalids);
          }
        }
      }
    }

    xhr.send(formData);
  }

  private update() {
    const slide = this.swiper.slides[this.swiper.activeIndex];
    const percent = (this.currentStep / (this.totalSteps)) * 100;

    this.$form.find('.progress-bar__current').html(this.currentStep.toString());
    this.$form.find('.progress-bar__current_name').html(slide.dataset.name);
    this.$form.find('.progress-bar__fill').css('width', `${percent}%`);

    this.$buttonPrev.toggleClass('hide', !this.hasPrev());
    this.$buttonNext.toggleClass('hide', !this.hasNext());

    this.$form.find('.progress-bar').toggleClass('hide', !this.hasNext());
    this.$form.find('.progress-info').toggleClass('hide', !this.hasNext());

    if (this.isLastStep) {
      this.$buttonNext.text('Получить расчёт');
    } else {
      this.$buttonNext.text(this.buttonNextText);
    }
  }

  private hasPrev(): boolean {
    if (this.swiper.activeIndex === 0)
      return false;

    if (this.swiper.activeIndex === this.totalSteps)
      return false;

    return true;
  }

  private hasNext(): boolean {
    if (this.swiper.activeIndex === this.totalSteps)
      return false;

    return true;
  }

  private onSuccess() {
    this.swiper.enabled = true;
    this.swiper.allowSlideNext = true;
    this.swiper.slideTo(this.totalSteps);
    this.swiper.enabled = false;
    this.swiper.allowSlideNext = false;
  }

  private onError(invalids: any[]) {
    this.swiper.enabled = true;

    for (const {name} of invalids) {
      const $input = this.$form.find(`[name="${name}"]`);

      if (!$input.length) {
        continue;
      }

      const $slide = $input.closest('.swiper-slide');

      if (!$slide.length) {
        continue;
      }

      this.swiper.slideTo($slide.index());
      break; // переходим к первому невалидному полю
    }

    this.shakeSwiper();
  }

  private shakeSwiper() {
    const el = this.swiper.el;
    const originalTransition = el.style.transition;

    const shakes = [10, -10, 6, -6, 3, -3, 0];

    let i = 0;

    function animate() {
      if (i >= shakes.length) {
        el.style.transition = originalTransition;
        return;
      }

      el.style.transition = 'transform 80ms';
      el.style.transform = `translate3d(${shakes[i]}px, 0, 0)`;

      i++;
      setTimeout(animate, 80);
    }

    animate();
  }
}

new TovarkeysStorageCostWizardForm('#tovarkeys_storage_cost_wizard');
